import storeButton from 'src/assets/images/antiscam/btn_store.png';

const MobileContent = () => {
  return (
    <div>
      소중한 내 가족을 위험한 피싱사기로부터 안전하게 보호하시려면,
      <br />
      반드시 '스마트피싱보호' 앱을 설치해 주셔야 합니다.
      <br />
      <br />
      <img src={storeButton} alt="" />
      <br />
      <span>클릭 시, 앱 스토어로 이동합니다.</span>
    </div>
  );
};

export default MobileContent;
